import { z } from 'zod';

import pgIntervalSchema from 'validationSchemas/pgInterval';

export const FormSchema = z.object({
  min_time_from_first_to_last: pgIntervalSchema.nullable(),
  max_time_from_first_to_last: pgIntervalSchema.nullable(),
  min_time_between_periods: pgIntervalSchema.nullable(),
  max_bookings_in_advance: z.number().nonnegative(),
  max_bookings_in_interval: z.number().nonnegative(),
  max_bookings_interval: pgIntervalSchema.nullable(),
  require_permit: z.boolean(),
  first_period_max_balance: z.number().nonnegative().nullable(),
  last_period_max_balance: z.number().nonnegative().nullable(),
  other_max_balance: z.number().nonnegative().nullable(),
});

export type FormInputValues = z.input<typeof FormSchema>;
export type FormOutputValues = z.output<typeof FormSchema>;
